import { AppText } from '../../../../../../../ui/text/AppText';

export const genericCommentColumnProps = {
  width: 321,
  render: text => <AppText>{text}</AppText>,
};
